<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="businessDetailOrderInfo.orders" border style="width: 100%">
        <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
        <el-table-column label="订单号" align="center">
          <template slot-scope="scope">
            {{scope.row.cartId}}({{scope.row.orderId}})
          </template>
        </el-table-column>
        <el-table-column prop="cartNum" label="购买数量" align="center"></el-table-column>
        <el-table-column prop="appName" label="平台" align="center"></el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            {{scope.row.cartType == '3307'?'服务':'商品'}}
          </template>
        </el-table-column>
        <el-table-column prop="personName" label="用户名称" align="center"></el-table-column>
        <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="deduction" label="优惠金额" align="center">
          <template slot-scope="scope">
            {{scope.row.deduction || 0}}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="订单状态" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openOrderDetailModel(scope.row)">订单详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="8"></el-col>
        <el-col :span="16" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    businessDetailOrderInfo: {
      type: Object,
      default: () => ({
        orders: [],
        link: ''
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    _openOrderDetailModel(order) {
      window.open(`/#/pages/goods/storeOrderCartDetail?orderId=${order.orderId}`)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('page-change', val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}
.text-right {
  text-align: right;
}
</style>